export const FETAL_CAUSES = { id: 'fetal_causes', label: 'Cause fetali' };
export const MATERNAL_CAUSES = { id: 'maternal_causes', label: 'Cause materne' };
export const NON_MEDICAL_INDICATION = {
  id: 'non_medical_indication',
  label: 'Indicazione non medica',
};
